import { RootState } from "store";

export function selectCandidateJsonData(state: RootState) {
  return state.products.candidate.data;
}

export function selectCandidateGetting(state: RootState) {
  return state.products.candidate.getting;
}
